import React, { Component } from "react";

class Features extends Component {

  render() {
    return(
      <div id="features">
      <h2>Features</h2>
      <p>Our software will check for exam openings at the dates and locations you tell us. When our service detects a new slot, we notify you through email and/or text. We'll continually send messages to you until the slot is taken.</p>

      <p>Disclaimer: We are not responsible for any charges you may incur for receiving emails or messages.</p>
      </div>
    )
  }
}

export default Features;